import { render, staticRenderFns } from "./ContactMergeModal.vue?vue&type=template&id=aed8612e"
import script from "./ContactMergeModal.vue?vue&type=script&lang=js"
export * from "./ContactMergeModal.vue?vue&type=script&lang=js"
import style0 from "./ContactMergeModal.vue?vue&type=style&index=0&id=aed8612e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports